import ThisModule from "./IDCard";

export default ThisModule;
